import { Label, TTranslator } from '@smartshell/ui-kit';
import dayjs from 'dayjs';

import { TLocalesKeys } from 'localization';
import { EShellMode } from 'types';

import { HostResponse } from '../interfaces';
import s from './Tooltip.module.scss';

const formatTime = (date: string): string => dayjs(date).format('HH:mm');
const formatBookingTime = (
  date: string,
  t: TTranslator<TLocalesKeys>
): string => {
  const today = dayjs();
  const bookingDate = dayjs(date);

  if (today.isSame(bookingDate, 'date')) {
    return t('today.at', bookingDate.format('HH:mm'));
  }

  return dayjs(date).format(`D MMM ${t('at')} HH:mm`);
};
const getBookingDuration = (
  from: string,
  to: string,
  t: TTranslator<TLocalesKeys>
): string =>
  `(${dayjs(to).diff(dayjs(from), 'hours')} ${t('time.contracted.hours')})`;

const getHostHeader = (
  host: HostResponse['hostOverview']
): { icon: JSX.Element; locale: TLocalesKeys } => {
  if (host.locked)
    return {
      icon: <Label iconName="LockIcon" color="gray-primary" />,
      locale: 'host.statuses.locked',
    };

  if (host.shell_mode === EShellMode.HIGH_ACCESS)
    return {
      icon: <Label iconName="TechModeIcon" color="red" />,
      locale: 'host.statuses.highAccess',
    };
  if (host.shell_mode === EShellMode.DISABLED)
    return {
      icon: <Label iconName="CircleCloseIcon" color="red" />,
      locale: 'host.statuses.shellRemoved',
    };

  if (host.in_service)
    return {
      icon: <Label iconName="ConeIcon" color="orange" />,
      locale: 'host.statuses.service',
    };

  if (host.client_sessions.length && !host.online)
    return {
      icon: <Label iconName="ExclamationIcon" color="red" />,
      locale: 'host.statuses.noConnection',
    };

  if (host.client_sessions.length)
    return {
      icon: <div className={s.sessionLabel} />,
      locale: 'host.statuses.session.active',
    };

  return {
    icon: (
      <Label
        iconName="ShutdownIcon"
        color={host.online ? 'green' : 'gray-primary'}
      />
    ),
    locale: host.online ? 'host.statuses.on' : 'host.statuses.off',
  };
};

export { formatTime, formatBookingTime, getBookingDuration, getHostHeader };
